import { useContext, useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Header from '../../components/headerAdmin/Header'
import RequisitionDetailsBody from './RequisitionDetailsBody.js';
import "../RequisitionDetails/RequisitionDetails.css"
import { UserTypeContext } from '../../AppRoute';
import checkRequisitionExists from "../../apis/checkRequisitionExists/checkRequisitionExists"
import CircularProgress from '@mui/material/CircularProgress';
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';


function RequisitionDetails() {
  const { id: requisitionId } = useParams();
  const location = useLocation();
  const locationState = location.state || {};
  const { userType, userRecords } = useContext(UserTypeContext);
  const idContextTest = locationState.id || userRecords?.id;
  const userRecruitmentpartnerId = locationState.userRecruitmentpartnerId || userRecords?.recruitmentpartnerId;
  const [checkRequisition, setCheckRequisition] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const requisitionCheck = async () => {
    setIsLoading(true)
    let payload = {
      requisitionId: requisitionId,
      userRecruitmentpartnerId: userRecruitmentpartnerId,
      userType: userType,
      userId: idContextTest,
      validation: "RequisitionCheckValidation"
    }
    let response = await checkRequisitionExists(payload);
    let data = response.data.data
    setCheckRequisition(data)
    setIsLoading(false)
  }

  useEffect(() => {
    requisitionCheck()
  }, [])

  return (
    <div className='mainContainer_requisitionDetails'>
      <div className='topContainer_requisitionDetails'>
        <Header />
        {(checkRequisition.length > 0) || userType === "Admin" || userType === "MIS Operator" || userType === "Organization Admin" ? (
          <RequisitionDetailsBody
            location={{ state: locationState, requisitionId }}
          />
        ) : (
          isLoading ? (
            <div className="loader_requisitionDetails">
              <CircularProgress color="inherit" size={50} />
            </div>
          ) : (
            <UnauthorizedAccess />
          )
        )}
      </div>
    </div>
  )
}

export default RequisitionDetails;

